// extracted by mini-css-extract-plugin
export var active = "_5q-c";
export var activeIndicator = "_5q-7";
export var animate = "_5q-b";
export var contentWidthTabs = "_5q-5";
export var disabled = "_5q-d";
export var flat = "_5q-1";
export var fullWidth = "_5q-3";
export var lg = "_5q-a";
export var md = "_5q-9";
export var redoButtonTabGroup = "_5q-0";
export var sm = "_5q-8";
export var tabButton = "_5q-4";
export var tabButtonsContainer = "_5q-2";
export var xs = "_5q-6";